// extracted by mini-css-extract-plugin
module.exports = {"link":"VideoPopup_link__S3WAl"};